import { isString, isNumber, isEmpty } from 'lodash-es'
import { mapUnitOrOriginal } from '@/components/combined-predict/components/CombinedPredictTable/utils/unitConversions'

const coerceNumberOrTrimmedString = (value) => {
  if (!isString(value) && !isNumber(value)) return null
  if (isString(value) && value.trim() === '') return null
  const num = Number(value)
  return Number.isFinite(num) ? num : isString(value) ? value.trim() : value
}

const formatScientific = (value, { precision = 2, blank = 'N/A', unit } = {}) => {
  const valueToFormat = coerceNumberOrTrimmedString(value)

  if (valueToFormat === null) return blank

  if (typeof valueToFormat === 'string') return valueToFormat

  const normalizedUnit = (unit) => (typeof unit === 'string' ? mapUnitOrOriginal(unit.trim().toLowerCase()) : '')
  const skipUnits = ['°C', 'K', '°F', 'celsius', 'kelvin', 'fahrenheit'].map(normalizedUnit)

  const num = Number(valueToFormat)
  const absNum = Math.abs(num)
  const shouldUseScientific =
    !skipUnits.includes(normalizedUnit(unit)) && num !== 0 && (absNum >= 1000 || absNum < 0.01)

  if (shouldUseScientific) {
    return num.toExponential(precision)
  }

  return num.toFixed(precision)
}

const formatDate = (dateString, { locales = 'en-US', withTime = true } = {}) => {
  if (!isString(dateString) || isEmpty(dateString)) return null
  const date = new Date(dateString)
  const isValid = date.getTime()
  const options = withTime
    ? { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
    : { day: 'numeric', month: 'short', year: 'numeric' }
  return isValid ? date.toLocaleDateString(locales, options) : dateString
}

export { coerceNumberOrTrimmedString, formatScientific, formatDate }
